import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiUser, FiTag, FiClock, FiSave } from "react-icons/fi";
import { FaClock } from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";
const CreateShift = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}/v1/shift`;
  
  // Ambil token dari local storage
  const token = localStorage.getItem("token");

  // Inisialisasi shift baru
  const initialShift = {
    name: "",
    code: "",
    start_time: "08:00", // Format time (HH:mm)
    end_time: "17:00",   // Format time (HH:mm)
  };

  const [shift, setShift] = useState(initialShift);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShift({ ...shift, [name]: value });
  };

  // Fungsi untuk menyimpan shift ke API
  const handleSave = async () => {
    if (!shift.name || !shift.code || !shift.start_time || !shift.end_time) {
      alert("Semua field harus diisi!");
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(shift),
      });
  
      if (!response.ok) throw new Error("Gagal menyimpan shift!");
  
      setShowSuccessModal(true); // Tampilkan modal sukses
  
      // Redirect ke halaman /enterprise/shift setelah 2 detik
      setTimeout(() => {
        navigate("/enterprise/shift");
      }, 2000);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="min-h-screen flex flex-col space-y-6 p-6 bg-gray-50 w-full min-w-0">
      <PageCreateHeader
        icon={FaClock}
        title="Buat Shift"
        description="Tambah jadwal shift kerja baru"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Shift", to: "/enterprise/shift" },
          { label: "Buat Shift" },
        ]}
      />

      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 w-full">
        <form>
          <div className="grid grid-cols-1 gap-6">
            {/* Nama */}
            <div>
              <label className="flex items-center text-sm font-medium text-gray-700 mb-1">
                <FiUser className="mr-2 text-green-500" />
                Nama Shift
              </label>
              <input
                type="text"
                name="name"
                value={shift.name}
                onChange={handleChange}
                placeholder="Contoh: Shift Pagi"
                className="w-full px-4 py-2 rounded-xl border border-gray-200 shadow-sm focus:ring-2 focus:ring-green-400 focus:outline-none transition"
              />
            </div>
    
            {/* Code */}
            <div>
              <label className="flex items-center text-sm font-medium text-gray-700 mb-1">
                <FiTag className="mr-2 text-green-500" />
                Kode Shift
              </label>
              <div className="flex space-x-3 mt-1">
                {["L", "S", "P"].map((code) => (
                  <button
                    key={code}
                    type="button"
                    onClick={() => setShift({ ...shift, code })}
                    className={`px-4 py-2 rounded-full text-sm font-semibold transition ${
                      shift.code === code
                        ? "bg-green-500 text-white shadow"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                    }`}
                  >
                    {code}
                  </button>
                ))}
              </div>
            </div>
    
            {/* Jam Mulai */}
            <div>
              <label className="flex items-center text-sm font-medium text-gray-700 mb-1">
                <FiClock className="mr-2 text-green-500" />
                Jam Mulai
              </label>
              <input
                type="time"
                name="start_time"
                value={shift.start_time}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl border border-gray-200 shadow-sm focus:ring-2 focus:ring-green-400 focus:outline-none transition"
              />
            </div>
    
            {/* Jam Pulang */}
            <div>
              <label className="flex items-center text-sm font-medium text-gray-700 mb-1">
                <FiClock className="mr-2 text-green-500" />
                Jam Pulang
              </label>
              <input
                type="time"
                name="end_time"
                value={shift.end_time}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl border border-gray-200 shadow-sm focus:ring-2 focus:ring-green-400 focus:outline-none transition"
              />
            </div>
          </div>
    
          {/* Tombol Simpan */}
          <div className="flex justify-end mt-8">
            <button
              type="button"
              onClick={handleSave}
              disabled={loading}
              className={`inline-flex items-center gap-2 px-5 py-2 rounded-xl text-white text-sm font-medium shadow-md transition ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-500 hover:bg-green-600"
              }`}
            >
              <FiSave className="text-lg" />
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
      {showSuccessModal && (
  <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
    <div className="bg-white rounded-xl shadow-lg p-6 w-[300px] text-center">
      <h2 className="text-xl font-semibold text-green-600 mb-2">Berhasil!</h2>
      <p className="text-sm text-gray-600">Shift baru berhasil dibuat.</p>
    </div>
  </div>
)}

    </div>
    
  );
};

export default CreateShift;
